export const Host = {
  BitBucket: "https://bitbucket.org/the-betlogs/pocket-guide-portal-images/raw",
  BitBucketMaster:
    "https://bitbucket.org/!api/2.0/repositories/the-betlogs/pocket-guide-portal-images/refs/branches/master",
  BitBucketApi:
    "https://bitbucket.org/!api/internal/repositories/the-betlogs/pocket-guide-portal-images/tree",
};
